<template>
    <div class="pamentCalc publicProfile row text-center justify-content-center">
        <div class="col-12 col-md-8 successBroker">
            <!-- <h4 class="mb-0 p-3">{{$t('declaration.text1')}}</h4> -->
            <img src="/assets/images/success14789.png" :alt="$t('decleration.text24')" :title="$t('decleration.text24')" />
            <div class="content mb-4 pb-3 genrateMessage">
                <h3 class="my-3 clash"><span class="bgTitle">{{$t('riskWarning.text2')}} {{ store.customerDetail?.firstName || '' }},</span></h3>
                <p><strong>{{$t('riskWarning.text5')}}</strong> {{$t('riskWarning.text5a')}}</p>
                <p>{{$t('riskWarning.text6')}}</p>
            </div>
        </div>
        <div class="col-12 col-md-5 mt-2">
            <button type="button" class="grd_btn full_size" @click="$parent.testPass = false">{{$t('declaration.text3')}}</button>
        </div>
    </div>
</template>
<script>
import { useMainStore } from "@/store";
    export default{
        setup() {
            const store = useMainStore();
            return { store };
        },
        data(){
            return {
                

            }
        },
    }
</script>